import { Component, Input } from '@angular/core'

export interface Crumb {
  label?: string;
  iconClass?: string;
  path?: string;
}
@Component({
  selector: 'app-st-breadcrumbs',
  templateUrl: './st-breadcrumbs.component.html',
  styleUrls: ['./st-breadcrumbs.component.scss'],
  standalone: false
})
export class StBreadcrumbsComponent {

  @Input() crumbs!: Array<Crumb>;
}
